import DeleteBoardMeeting from "./DeleteBoardMeeting";
export default DeleteBoardMeeting;
